<script setup>
import {reactive} from 'vue'
import {useItemDataStore} from '@/stores/itemData'

const props = defineProps({
    options: Object,
})

const emit = defineEmits(['hide-modal'])

const itemDataStore = useItemDataStore()

const row = reactive({...props.options.row})

const saveNote = () => {
    itemDataStore.update({
        tableName: 'odp_course_bookings',
        id: row.id,
        data: {
            paymentNote: row.paymentNote
        }
    })
}
</script>

<template>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Notes</h4>

                <button
                    type="button"
                    class="btn-close"
                    @click="emit('hide-modal')"
                    aria-label="Close"
                ></button>
            </div>
            <div class="modal-body">
                <textarea
                    v-model="row.paymentNote"
                    placeholder="Type here…"
                    rows="10"
                    style="padding: 15px; width: 100%; font-size: 18px; background: #fff; border: none;"
                    @change="saveNote"
                />
            </div>
        </div>
    </div>
</template>